<template>
    <section class="cz2__splash">
        <!-- SPELLING BEE START: Show confirmation modal. -->
        <transition name="cz2__fade">
            <sb-selector-modal
                v-if="isSpellingBeeOptionAvailable && showSbSelectorModal"
                @confirm="showTwoPackSelector = true"
                @close="showTwoPackSelector = true"
            />
        </transition>
        <!-- SPELLING BEE END -->

        <!-- MARINERS START -->
        <funko-logo
            v-if="isMarinersOptionAvailable"
            class="cz2__splash__logo--mariners"
        />

        <polka-dot-background v-if="!isSpellingBee && !isMariners" />

        <transition name="cz2__fade">
            <img
                v-if="(showTwoPackSelector && isKiosk)"
                src="../assets/images/pop-yourself-logo.svg"
                alt="Pop! Yourself Logo"
                class="cz2__splash__logo"
                @click.prevent="tapLogo"
            >
        </transition>

        <transition name="cz2__fade">
            <button
                v-if="showIntro"
                class="cz2__splash__intro"
                @click.prevent="introTapped"
            >
                <video
                    v-if="introVideoUrl"
                    id="funko-intro-video"
                    class="cz2__intro__video"
                    autoplay
                    loop
                    muted
                    playsinline
                    :src="introVideoUrl"
                />
            </button>
        </transition>

        <transition name="cz2__fade">
            <button
                v-if="isKiosk && showScreensaver && screensaverImage"
                @click="closeScreensaver"
                type="button"
                :style="{ backgroundImage: `url(${screensaverImage})` }"
                class="cz2__splash__screensaver"
            />
        </transition>

        <two-pack-selector
            v-if="showTwoPackSelector"
            @start="(type) => start(type)"
        />

        <transition name="cz2__fade">
            <funko-spinner v-if="showSpinner" />
        </transition>

        <sb-animation ref="sbAnimation" />

        <netflix-copyright />
    </section>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__splash {
            width: 100%;
            height: 100%;

            background-position: center;
            background-repeat: repeat;
            background-size: contain;

            .cz2__splash__intro {
                display: block;

                position: relative;
                margin: 0 auto;

                width: 100%;
                height: 100%;

                border: none;
                background: none;
            }
        }

        .cz2__splash__screensaver {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
        }

        .cz2__intro__video {
            display: none;
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__splash__logo {
            position: absolute;

            top: 24px;
            right: 24px;

            width: 187px;
            height: 165px;

            z-index: 99;
        }

        .cz2__intro__video {
            display: block;

            width: 100%;
            height: 100%;

            object-fit: cover;
            object-position: center bottom;
        }

        .cz2__splash__content {
            width: 100%;
            height: 100%;

            padding: 80px;

            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            // background: #0061a5 url(../assets/images/splash/landing-blue.jpg) no-repeat center/cover;

            .cz2__splash__header {
                text-align: center;
            }

            .intro-card {
                background: #fff;
                box-shadow: color(dropshadowBorder) 10px 10px 0 0;
                padding: 64px 48px;
                display: inline-block;
                max-width: 514px;

                text-align: left;

                h1, p {
                    margin: 0;
                }

                .intro-pre-header {
                    @include font(eyebrow);
                    margin-bottom: 8px;
                }

                h1 {
                    @include font(xl-feature);
                    margin-bottom: 8px;
                }

                .card-description {
                    @include font(bodyRegular);
                    margin-bottom: 24px;
                    width: 336px;
                }

                .card-price {
                    @include font(h2);
                }
            }

            .intro-character-preview {
                text-align: center;
                margin-top: -104px;
                margin-bottom: 72px;
            }

            .navigation-row {
                text-align: center;
            }

            .start-cta {
                min-width: 464px;
                min-height: 64px;
                background: color(secondaryYellow);
                border-radius: 32px;
                font-family: var(--cz-font-700-family);
                font-weight: var(--cz-font-700-weight);
                font-size: 22px;
                text-transform: uppercase;
                color: #000;

                transition: all $transition-fast ease-out;

                &.cz2__start-cta--error {
                    background: color(secondaryRed);
                    color: color(primaryWhite);
                }
            }

            .offline-message {
                display: none;

                text-align: center;
                @include font(bodyRegular);
                color: color(primaryWhite);
                margin-top: 24px;
            }
        }
    }

    #cz2.cz2.cz2__is-mariners {
        .cz2__splash {
            background: #000;
            background-image: url(../assets/images/branded/knicks/notplash-bg.webp);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;

            .cz2__funko-logo-wrapper {
                gap: 40px;
            }

            .cz2__funko-logo,
            .cz2__funko-logo-link {
                width: 100px;
                height: 34px;
            }

            .sm-seattle-logo {
                width: 56px;
                height: 56px;
            }

            .cz2__splash__logo--mariners {
                padding-top: 16px;
                display: flex;
                justify-content: center;
            }

            @include respond-above(sm) {
                .cz2__splash__logo--mariners {
                    padding-top: 40px;
                }
            }

            @include respond-above(lg) {
                .cz2__funko-logo-wrapper {
                    gap: 98px;
                }

                .sm-seattle-logo {
                    height: 110px;
                    width: 110px;
                }
                .sm-x-icon {
                    height: 52px;
                }

                .cz2__funko-logo,
                .cz2__funko-logo-link {
                    height: 64px;
                    width: auto;
                }
            }

            @include respond-below(lg) {
                .cz2__copyright-br {
                    display: none;
                }
            }
        }
    }
</style>

<script>
    import axios from 'axios';

    import FunkoSpinner from './ui/FunkoSpinner.vue';
    import TwoPackSelector from './TwoPackSelector.vue';
    import PolkaDotBackground from './ui/PolkaDotBackground.vue';
    import backgroundImage from '../assets/images/blue-polka-dots@2x.svg';
    import SbBackground from './ui/SbBackground.vue';
    import SbSelectorModal from './SbSelectorModal.vue';
    import SbAnimation from './SbAnimation.vue';
    import FunkoLogo from './FunkoLogo.vue';
    import NetflixCopyright from './NetflixCopyright.vue';

    // import { getAts } from '../helpers/productData';

    export default {
        components: {
            FunkoSpinner,
            TwoPackSelector,
            SbBackground,
            PolkaDotBackground,
            SbSelectorModal,
            SbAnimation,
            FunkoLogo,
            NetflixCopyright,
        },

        data() {
            return {
                showSpinner: false,

                showIntro: false,

                showTwoPackSelector: false,

                backgroundImage,

                sbAnimationVideoFile: null,
            };
        },

        computed: {
            /**
             * Current step.
             */
            selectedStep() {
                return this.$store.state.selectedStep;
            },

            // Spelling bee option enabled.
            isSpellingBeeOptionAvailable() {
                return this.$store.state.isSpellingBeeOptionAvailable;
            },

            isMarinersOptionAvailable() {
                return this.$store.state.isMarinersOptionAvailable;
            },

            showSbSelectorModal() {
                if (this.showIntro) {
                    return false;
                }
                return this.$store.state.showSbSelectorModal;
            },

            isOnline() {
                // E-commerce flow should have it always as true.
                return this.$store.state.isOnline;
            },

            legacyCtaText() {
                return this.isOnline ? this.$t('START') : this.$t('INTERNET_ERROR');
            },

            haveOptions() {
                return this.$store.state.options != null;
            },

            haveSettings() {
                if (this.$store.state.options != null && this.$store.state.customizer.globalSettings != null) {
                    return this.$store.state.customizer.globalSettings;
                }

                return null;
            },

            options() {
                return this.haveSettings ? this.$store.state.options : null;
            },

            globalSettings() {
                return this.haveSettings ? this.$store.state.customizer.globalSettings?.blueprint?.custom : null;
            },

            recipe() {
                return this.options?.recipe;
            },

            isKiosk() {
                return this.options?.isKiosk;
            },

            skipLanding() {
                return this.options?.skipLanding;
            },

            disableTwoPack() {
                if (this.options?.disableTwoPack) {
                    return true;
                }

                if (this.globalSettings?.['fun-disable-two-pack'] === 'true') {
                    return true;
                }

                const requiredSkus = (this.globalSettings?.['fun-two-packs-require-skus'] || '').split(',').map((x) => x.trim()).filter((x) => x.length > 0);
                if (requiredSkus.length > 0) {
                    const settingsController = this.$store.state.customizer.globalSettings;

                    const stockCheck = settingsController.findPlacement('POPStockCheck');

                    // eslint-disable-next-line no-restricted-syntax
                    for (const sku of requiredSkus) {
                        const component = stockCheck.components.find((x) => x.custom['fun-sku'] === sku);

                        if (component == null) {
                            // No component, disable two pack.
                            return true;
                        }

                        if (!settingsController.isAvailable(component)) {
                            return true;
                        }

                        // const ats = getAts(this.$store.state.ecommerce, component);

                        // const inventory = settingsController

                        // console.log('!!!!!11111', ats);
                    }
                }

                return false;
            },

            screensaverImage() {
                return this.$store.state.customizer.globalSettings.blueprint?.custom['fun-kiosk-screensaver-image'];
            },

            introVideoUrl() {
                const url = this.globalSettings?.['fun-intro-video'];

                if (url == null || url === 'none') {
                    return null;
                }

                return url;
            },

            loadState() {
                return this.$store.state.loadState;
            },

            outOfPaper() {
                return this.$store.getters.outOfPaper;
            },

            getImage() { return `${this.pops[this.counter % this.pops.length]}`; },

            splashTimerInterval() {
                return 1500;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            isMariners() {
                return this.$store.state.isMariners;
            },

            aiSpinnerShown() {
                return this.$store.state.aiSpinnerShown;
            },

            showScreensaver() {
                return this.$store.state.screensaverShown;
            },
        },

        watch: {
            selectedStep(newValue) {
                // When timing out while in the splashSelector step, that doesn't trigger the component reload.
                // So we need to refresh settings.
                if (newValue === 'splash') {
                    this.loadSettings();
                }
            },

            haveOptions() {
                this.loadSettings();
            },

            haveSettings(newValue) {
                if (newValue) {
                    this.checkSettings();
                }
            },

            loadState() {
                // Loaded successfully, start the customization.
                if (this.loadState === 'loaded') {
                    this.$store.dispatch('selectStep', 'customize');

                    this.$store.dispatch('showAiSpinner', false);
                }

                // Something went wrong, retry.
                if (this.loadState === 'error') {
                    this.loadErrorTimer = setTimeout(() => {
                        this.resetLoadError();
                        this.$store.dispatch('startCustomization');
                    }, 60000);

                    this.$store.dispatch('showAiSpinner', false);
                }
            },

            aiSpinnerShown() {
                if (this.aiSpinnerShown) {
                    this.showTwoPackSelector = false;
                }
            },
        },

        beforeMount() {
            this.$store.dispatch('setIsSpellingBee', false);
            this.$store.dispatch('setShowSbSelectorModal', false);

            this.$store.dispatch('setIsMariners', true);
            this.showTwoPackSelector = true;
        },

        mounted() {
            this.loadSettings();
        },

        methods: {
            loadSettings() {
                if (this.haveOptions) {
                    // Load settings controller.
                    this.$store.dispatch('loadSettings');
                }
            },

            checkSettings() {
                if (this.recipe) {
                    // Check if recipe actually exists.
                    axios.get(`https://cz.drrv.co/recipe/${this.recipe}.json`).then((response) => {
                        this.checkSettingsContinue(true, response.data);
                    }).catch(() => {
                        this.checkSettingsContinue(false);
                    });
                } else {
                    this.checkSettingsContinue(false);
                }
            },

            checkSettingsContinue(haveRecipe, recipe) {
                // Automatically load details and start customizing when a starting recipe is provided.
                if (this.recipe && haveRecipe) {
                    // TODO: Determine the type of the recipe.
                    this.start('one-pack');

                    // Automatically enable SB.
                    if (this.haveSettings.blueprint.custom['fun-sb-enabled']) {
                        if (recipe.custom['fun-spelling-bee'] === 'true') {
                            this.$store.dispatch('setIsSpellingBeeAvailable', true);
                            this.$store.dispatch('setShowSbSelectorModal', false);
                            this.$store.dispatch('setIsSpellingBee', true);
                        }
                    }

                    // Bail out unconditionally.
                    return;
                }

                // Is SB available?
                if (this.haveSettings.blueprint.custom['fun-sb-enabled']) {
                    this.$store.dispatch('setIsSpellingBeeAvailable', true);
                }

                // Is Mariners available?
                this.$store.dispatch('setIsMarinersAvailable', true);
                // Set to true by default, set to untrue if user opts out via modal
                this.$store.dispatch('setIsMariners', true);
                if (this.haveSettings.blueprint.custom['fun-first-accessory-zero-price-override'] === 'true') {
                    this.$store.dispatch('setFirstAccessoryFree', true);
                }

                if (this.haveSettings.blueprint.custom['fun-first-accessory-zero-price-override'] === 'false') {
                    this.$store.dispatch('setFirstAccessoryFree', false);
                }

                // E-commerce
                if (this.skipLanding) {
                    if (this.disableTwoPack) {
                        this.start('one-pack');
                    } else {
                        this.showIntro = false;
                        this.$store.dispatch('selectStep', 'splashSelector');
                    }
                } else {
                    // Kiosk doesn't skip landing.

                    // Show the screensaver.
                    if (this.screensaverImage?.length > 0) {
                        this.$store.dispatch('setScreensaverShown', true);
                    } else {
                        this.showIntro = true;
                    }

                    this.showTwoPackSelector = false;
                }
            },

            closeScreensaver() {
                this.$store.dispatch('setScreensaverShown', false);
                // Show the intro video.
                this.showIntro = true;
            },

            /**
             * Intro video was tapped, figure out what's next.
             */
            introTapped() {
                // Actually, don't prevent users from building.
                //
                // Do nothing if out of paper.
                // if (this.outOfPaper) {
                //     return;
                // }

                if (this.disableTwoPack) {
                    this.start('one-pack');
                } else {
                    this.showIntro = false;
                    this.showTwoPackSelector = true;

                    this.$store.dispatch('selectStep', 'splashSelector');
                }
            },

            /**
             * Start customization of the given type.
             */
            start(type) {
                this.hideSiteElements();

                this.showSpinner = true;

                this.resetLoadError();

                // Scroll to the app. Prevents height weirdness after entering name in modal.
                this.$store.dispatch('scrollToApp');

                // Begin customization.
                this.$store.dispatch('log', {
                    level: 'info',
                    message: 'Start customization from splash page',
                });

                this.$store.dispatch('startCustomization', {
                    mode: type,
                });

                this.logStartEvent(type);

                this.showTwoPackSelector = false;
            },

            logStartEvent(type) {
                const eventName = type === 'two-pack' ? 'pop_people_start_two_pack' : 'pop_people_start_single';

                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: eventName,
                    });
                }
            },

            /**
             * Clear previous load errors so we can start fresh.
             */
            resetLoadError() {
                this.$store.dispatch('loadState', null);

                if (this.loadErrorTimer) {
                    clearTimeout(this.loadErrorTimer);
                }
            },

            tapLogo() {
                this.$store.dispatch('tapLogo');
            },

            showSb() {
                if (this.$refs.sbAnimation) {
                    this.$refs.sbAnimation.play(() => {
                        this.$store.dispatch('setIsSpellingBee', true);
                    });
                }
            },

            hideSiteElements() {
                // Hide site header and footer.
                const siteHeader = document.getElementById('site-header');
                const siteFooter = document.getElementById('footercontent');
                const wrapper = document.querySelector('#cz2.cz2');
                // eslint-disable-next-line
                const body = document.body;
                const page = document.getElementsByClassName('page');
                const chatRegion = document.getElementById('embeddedMessagingLiveRegion');

                if (wrapper) {
                    wrapper.style.setProperty('overflow', 'hidden');
                }

                if (body) {
                    body.style.setProperty('overflow', 'hidden');
                }

                if (page.length) {
                    page[0].style.marginTop = 0;
                }

                if (siteHeader) {
                    siteHeader.style.setProperty('display', 'none');
                }

                if (siteFooter) {
                    siteFooter.style.setProperty('display', 'none');
                }

                // Prevent whitespace at bottom of screen.
                if (chatRegion) {
                    chatRegion.style.setProperty('display', 'none');
                }
            },
        },
    };
</script>
